/**
 * PDF.js Bootstrap - Initialize worker path
 * Import once at app startup
 */
import * as pdfjsLib from 'pdfjs-dist/build/pdf';

// Set worker path for PDF.js
// Using CDN for simplicity (works in all environments)
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

console.log('[PDF.js] Worker configured:', pdfjsLib.GlobalWorkerOptions.workerSrc);

export default pdfjsLib;
